/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Action from './Action/index'
import Chair from './Chair/index'
import CheckedInAt from './CheckedInAt/index'
import Color from './Color/index'
import Name from './Name/index'
import Profile from './Profile/index'
import React from 'react'
import StartsAt from './StartsAt/index'
import Type from './Type/index'
import WaitingTime from './WaitingTime/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/Appointments/Content/Appointment",
  onMouseEnter,
  onMouseLeave,
  isOver10Min,
  isHoveredManual,
  onMouseEnterName,
  onMouseLeaveName,
  hoveredName
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let appointmentBookingItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking_item',
path: 'isFirst',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
let dtColorsGreen100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  isOver10Min,
  isHoveredManual,
  onMouseEnterName,
  onMouseLeaveName,
  hoveredName
  
})
  return (<React.Fragment
>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--bc-2-dUIJ5': isOver10Min ? dtColorsRed200 : isHoveredManual ? dtColorsGreen100 : dtColorsWhite,'--mt-1-dUIJ5': appointmentBookingItemIsFirstValueData ? "0px" : "4px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Action
  viewPath={`${viewPath}/Action`}
 is_hovered={isHoveredManual}
/>
</div>
<Color
  viewPath={`${viewPath}/Color`}
/>
<div
  data-testid="Appointment.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Profile
  viewPath={`${viewPath}/Profile`}
/>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Appointment.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<WaitingTime
  viewPath={`${viewPath}/WaitingTime`}
/>
<StartsAt
  viewPath={`${viewPath}/StartsAt`}
/>
</div>
<div
  data-testid="Appointment.Horizontal:4"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnterName}
 onMouseLeave={onMouseLeaveName}
 className={`views-block ${styles.Horizontal4}`}
>
<Name
  viewPath={`${viewPath}/Name`}
 hovered={hoveredName}
/>
<Chair
  viewPath={`${viewPath}/Chair`}
/>
</div>
<div
  data-testid="Appointment.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<CheckedInAt
  viewPath={`${viewPath}/CheckedInAt`}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}